module.exports = __webpack_public_path__ + "static/media/photoshop.8ca8f89d.svg";